import React from 'react'
import { Text, View } from 'react-native'
import {
  BG_STYLES,
  BUTTON_STATUS,
  Button,
  BUTTON_TYPE,
  CenterModal,
  COMMON_STYLES,
  SIZE,
  TEXT_STYLES,
  TYPOGRAPHY,
} from '@dehaat/dds'
import { useTranslation } from 'react-i18next'

type Props = {
  styles: any
  isVisible: boolean
  actionLoading: boolean
  onClose: () => void
  onConfirm: () => void
}

const DemoDetailApproveConfirmModal = ({
  styles,
  isVisible,
  actionLoading,
  onClose,
  onConfirm,
}: Props) => {
  const { t } = useTranslation()

  return (
    <CenterModal isVisible={isVisible} onClose={onClose} allowClose={!actionLoading}>
      <Text style={[TYPOGRAPHY.HEADING3, TEXT_STYLES.textNeutral90]}>
        {t('demo_approve_requests_title')}
      </Text>
      <Text style={[TYPOGRAPHY.TEXT2, TEXT_STYLES.textNeutral80, COMMON_STYLES.mv1]}>
        {t('demo_approving_single')}
      </Text>
      <View style={[COMMON_STYLES.row, { gap: 12 }]}>
        <Button
          buttonStyle={[BG_STYLES.bgNeutral00, COMMON_STYLES.flex1, styles.modalBtn]}
          onClick={onClose}
          type={BUTTON_TYPE.PRIMARY}
          text={t('cancel')}
          size={SIZE.small}
          status={actionLoading ? BUTTON_STATUS.DISABLED : BUTTON_STATUS.ACTIVE}
          textStyle={[TEXT_STYLES.textNeutral70]}
        />
        <Button
          buttonStyle={[BG_STYLES.bgPrimary100, COMMON_STYLES.flex1, styles.modalBtn]}
          onClick={onConfirm}
          type={BUTTON_TYPE.PRIMARY}
          text={actionLoading ? t('demo_please_wait') : t('approve')}
          size={SIZE.small}
          status={actionLoading ? BUTTON_STATUS.DISABLED : BUTTON_STATUS.ACTIVE}
          textStyle={[TEXT_STYLES.textNeutral00]}
        />
      </View>
    </CenterModal>
  )
}

export default DemoDetailApproveConfirmModal
